// extracted by mini-css-extract-plugin
module.exports = {"main":"AppRedirectPayBtn_main__m75Lm"};